import { type FC, type ReactNode } from "react";

import { Colors } from "@snapchat/snap-design-system";
import { Sizes, WarningIcon } from "@snapchat/snap-design-system-icons";

import { UpdateMessageLine } from "./UpdateMessage.styles";
import { UpdateMessagePreviousLabel } from "./messages.generated";

interface UpdateMessageProps {
    children: ReactNode;
    displayLabel?: boolean;
}

export const UpdateMessage: FC<UpdateMessageProps> = ({ children: previousFieldValue, displayLabel = true }) => {
    const updateLabel = displayLabel ? <UpdateMessagePreviousLabel /> : null;
    if (!previousFieldValue) {
        return null;
    }
    return (
        <UpdateMessageLine>
            <WarningIcon fill={Colors.Orange.V200} size={Sizes.Small} />
            {updateLabel}
            {previousFieldValue}
        </UpdateMessageLine>
    );
};
